// import valid from 'card-validator';

// const validateCard = () => {

//   // use card number to get card type

//   const cardNumber = document.querySelector<HTMLInputElement>('#cardNumber');
//   const validate = valid.number(cardNumber.value);
//

// }

const numbersOnly = (element) => {
  const val = element.value.replace(/\D/g, '');

  element.value = `${val}`;
};

(function () {
  const cardNumber = document.querySelector<HTMLInputElement>('#cardNumber');
  const cardMonth = document.querySelector<HTMLInputElement>('#expiryMonth');
  const cardYear = document.querySelector<HTMLInputElement>('#expiryYear');
  const cardCVV = document.querySelector<HTMLInputElement>('#CVV');

  if (cardNumber) {
    cardNumber.addEventListener('blur', () => {
      numbersOnly(cardNumber);
    });
  }
  if (cardMonth) {
    cardMonth.addEventListener('blur', () => {
      numbersOnly(cardMonth);
    });
  }
  if (cardYear) {
    cardYear.addEventListener('blur', () => {
      numbersOnly(cardYear);
    });
  }
  if (cardCVV) {
    cardCVV.addEventListener('blur', () => {
      numbersOnly(cardCVV);
    });
  }
})();

(function () {
  try {
    const PaymentFormButton = document.getElementById('process-payment-button') as HTMLButtonElement;
    console.debug('FED log: PaymentFormButton', PaymentFormButton);

    if (PaymentFormButton) {
      PaymentFormButton.addEventListener('click', function () {
        console.debug('FED log: PaymentFormButton clicked, setting it to disabled');
        PaymentFormButton.disabled = true;
        // Enough time to stop double click
        setTimeout(() => {
          console.debug('FED log: Waited 2000ms setting removing disabled state from PaymentFormButton');
          PaymentFormButton.disabled = false;
        }, 2000);
      });
    }
  } catch (e) {
    console.log(e);
  }
})();
